import { PaymentMethod, paymentMethodLabelMap } from 'src/@types/box-office';

/** Legacy values stored in `engedelyezett_fizetesi_modok` before PaymentMethod enum alignment. */
const LEGACY_PAYMENT_METHOD_TO_ENUM: Record<string, PaymentMethod> = {
  cashHUF: PaymentMethod.CASH,
  cashEUR: PaymentMethod.CASH,
  cash: PaymentMethod.CASH,
  keszpenz: PaymentMethod.CASH,
  creditCard: PaymentMethod.CARD,
  card: PaymentMethod.CARD,
  bankkartya: PaymentMethod.CARD,
  szepCard: PaymentMethod.OTP_SZEP_CARD,
  szepkartya: PaymentMethod.OTP_SZEP_CARD,
  otpSzepCard: PaymentMethod.OTP_SZEP_CARD,
  otp_szepkartya: PaymentMethod.OTP_SZEP_CARD,
  mbhSzepCard: PaymentMethod.MBH_SZEP_CARD,
  mbh_szepkartya: PaymentMethod.MBH_SZEP_CARD,
  transfer: PaymentMethod.TRANSFER,
  atutalas: PaymentMethod.TRANSFER,
  other: PaymentMethod.OTHER,
  egyeb: PaymentMethod.OTHER,
  voucher: PaymentMethod.VOUCHER,
  utalvany: PaymentMethod.VOUCHER,
  roomLoan: PaymentMethod.ROOM_LOAN,
  szoba_hitel: PaymentMethod.ROOM_LOAN,
};

export const normalizePaymentMethod = (value: string): PaymentMethod | null => {
  const trimmed = value.trim();

  if (!trimmed) {
    return null;
  }

  if (Object.values(PaymentMethod).includes(trimmed as PaymentMethod)) {
    return trimmed as PaymentMethod;
  }

  const legacyMatch = LEGACY_PAYMENT_METHOD_TO_ENUM[trimmed];

  if (legacyMatch) {
    return legacyMatch;
  }

  return null;
};

export const parseEnabledOfflinePaymentMethods = (
  enabledOfflinePaymentMethods?: string | null
): PaymentMethod[] => {
  if (!enabledOfflinePaymentMethods) {
    return [PaymentMethod.CASH, PaymentMethod.CARD];
  }

  const methods = enabledOfflinePaymentMethods
    .split(',')
    .map(normalizePaymentMethod)
    .filter((method): method is PaymentMethod => method !== null);

  if (methods.length === 0) {
    return [PaymentMethod.CASH, PaymentMethod.CARD];
  }

  return [...new Set(methods)];
};

export const getPaymentMethodLabelKey = (
  paymentMethod: PaymentMethod | string
): string | undefined => {
  const normalized =
    typeof paymentMethod === 'string' ? normalizePaymentMethod(paymentMethod) : paymentMethod;

  if (!normalized) {
    return undefined;
  }

  return paymentMethodLabelMap[normalized];
};
